import { useCallback } from "react";

import { useScrollGroupContext } from "./context";

/**
 * Returns a function that sets the scroll position of all items directly.
 */
export function useScrollGroupSetScroll() {
  const { scrollGroupItemsRef } = useScrollGroupContext();

  const setScroll = useCallback(
    (element: HTMLElement, offset: { left?: number; top?: number }) => {
      if (
        offset.left !== undefined &&
        Math.floor(offset.left) !== Math.floor(element.scrollLeft)
      ) {
        element.scrollLeft = offset.left;
      }
      if (
        offset.top !== undefined &&
        Math.floor(offset.top) !== Math.floor(element.scrollTop)
      ) {
        element.scrollTop = offset.top;
      }
    },
    [],
  );

  return useCallback(
    (offset: { left?: number; top?: number }) => {
      scrollGroupItemsRef.current?.forEach(({ refObject }) => {
        if (refObject?.current) {
          setScroll(refObject.current, offset);
        }
      });
    },
    [scrollGroupItemsRef, setScroll],
  );
}
